module.exports = __webpack_public_path__ + "img/logo.efd1dee4.png";